import { Mail, Subject, Today } from '@mui/icons-material';
import {
  AppDrawerMenu,
  AppName,
  HomeAppBar,
  PageWithDrawer,
} from '@prismamedia/one-components';
import { Role } from '@prismamedia/one-user';
import { BrandSwitch } from 'components/BrandSwitch';
import React, { ReactNode, FC } from 'react';
import { useGlobalBrandKey } from 'utils/globalState';
import { useQueryParams } from 'utils/useQueryParams';
import { BrandKey } from '__generated__/queries-newsletter';
import { paths } from '../../../routing';
import { auth } from '../../../utils/auth';
import { useStyles } from './styles';

export enum PageId {
  CAMPAIGN = 'campaign',
  NEWSLETTER = 'newsletter',
  CALENDAR = 'calendar',
}

interface Page {
  id: PageId;
  label: string;
  icon: JSX.Element;
  href: string;
}

const getPages = (brand?: BrandKey, isAdmin?: boolean): Page[] => {
  const brandQueryParam = brand ? `?brand=${brand}` : '';

  const pages = [
    {
      id: PageId.CAMPAIGN,
      label: 'Campagnes',
      icon: <Mail />,
      href: `${paths.CAMPAIGN_LIST}${brandQueryParam}`,
    },
    {
      id: PageId.NEWSLETTER,
      label: 'Templates',
      icon: <Subject />,
      href: `${paths.NEWSLETTER_LIST}${brandQueryParam}`,
    },
    {
      id: PageId.CALENDAR,
      label: 'Calendrier',
      icon: <Today />,
      href: `${paths.CALENDAR}${brandQueryParam}`,
    },
  ];

  if (isAdmin) return pages;
  return pages.filter(({ id }) => id !== PageId.NEWSLETTER);
};

interface ListPageProps {
  filterDrawer?: JSX.Element;
  searchBar?: JSX.Element;
  children: ReactNode;
  type: PageId;
}

export const ListPage: FC<ListPageProps> = ({
  type,
  filterDrawer,
  searchBar,
  children,
}) => {
  const classes = useStyles();
  const [brandKey] = useGlobalBrandKey();
  const isAdmin =
    auth.user?.isSuperAdmin() || auth.user?.hasRole(Role.NlAdmin as any);
  const pages = getPages(brandKey, !!isAdmin);
  useQueryParams();

  return (
    <>
      <HomeAppBar
        appDrawerMenu={
          <AppDrawerMenu
            appName={AppName.Newsletter}
            topSection={pages.map(({ id, label, icon, href }) => ({
              id,
              label,
              icon,
              selected: id === type,
              href,
            }))}
            disconnectUser={auth.logout}
            overriddenAppUrls={{
              [AppName.Authors]: `${config.FRONT_ONE_WEB}/#/authors/list`,
              [AppName.Diapo]: `${config.FRONT_ONE_WEB}/#/slideshow/list?status=Published`,
              [AppName.People]: config.FRONT_ONE_PERSON,
              [AppName.Photo]: config.FRONT_ONE_PHOTO,
              [AppName.Recipe]: config.FRONT_ONE_RECIPE,
              [AppName.Story]: config.FRONT_ONE_TOPIC,
              [AppName.Web]: `${config.FRONT_ONE_WEB}`,
            }}
          />
        }
        brandMenu={<BrandSwitch />}
        searchBar={searchBar}
        currentUser={auth.user}
        disconnectUser={auth.logout}
      />
      <PageWithDrawer
        leftDrawer={filterDrawer}
        fullWidth
        className={classes.listWrapper}
      >
        {children}
      </PageWithDrawer>
    </>
  );
};
